import React, { ReactNode } from 'react';

import classNames from 'classnames';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './VideoBlock.module.scss';

type VideoBlockProps = {
  title: ReactNode;
  description: ReactNode;
  videoUrl: string;
  videoName: string;
  className?: string;
};

const VideoBlock = ({
  title,
  description,
  videoUrl,
  videoName,
  className,
}: VideoBlockProps) => {
  return (
    <div className={classNames(classes.container, className)}>
      <TitleWithDescription
        title={title}
        description={description}
        titleFont="title-18-bold"
      />
      <iframe
        src={videoUrl}
        title={videoName}
        allowFullScreen
        className={classes.video}
      />
    </div>
  );
};

export { VideoBlock };
